import axios from 'axios';
import { call, put } from 'redux-saga/effects';
import { actions as formActions } from '@/reducers/form';
import { API } from '@/config/constants/api';

/* Global */
export const cleanValuesFromState = (data) => {
  const dataFinal = {};
  const dataKeys = Object.keys(data);
  dataKeys.forEach((key) => {
    if (
      key !== 'formFilled'
      && key !== 'infoOp'
      && key !== 'operation'
      && key !== 'entityData'
      && key !== 'formType'
      && key !== 'buttonVisible'
      && key !== 'entityRows'
      && key !== 'fieldArray'
      && key !== 'deleteCheck'
      && key !== 'entityValues'
      && key !== 'inputsGaps'
    ) {
      dataFinal[key] = data[key];
    }
  });
  return dataFinal;
}

// DELETE
export const deleteEntityFetch = (data) => {
  return axios({
    method: 'POST',
    url: API.FORM.DELETE_ENTITY,
    withCredentials: true,
    data,
  })
}
export function* deleteEntity({ params }) {
  try {
    const dataFinal = cleanValuesFromState(params);
    const response = yield call(deleteEntityFetch, dataFinal);
    yield put(formActions.setDeleteEntityResult(response.data));
  } catch (err) {
    console.log(err);
    yield put(formActions.setDeleteEntityResult({
      infoOp: 'Se ha producido un error inesperado',
      operation: 'error',
    }));
  }
}

// UPDATE
export const updateEntityFetch = (data) => {
  return axios({
    method: 'POST',
    url: API.FORM.UPDATE_ENTITY,
    withCredentials: true,
    data,
  })
}
export function* updateEntity({ params }) {
  try {
    const dataFinal = cleanValuesFromState(params);
    const response = yield call(updateEntityFetch, dataFinal);
    yield put(formActions.setUpdateEntityResult(response.data));
  } catch (err) {
    yield put(formActions.setUpdateEntityResult({
      infoOp: 'Se ha producido un error inesperado',
      operation: 'error',
    }));
  }
}
// SHOW
export const showEntityFetch = (data) => {
  return axios({
    method: 'POST',
    url: API.FORM.GET_ENTITY_ROWS,
    withCredentials: true,
    data,
  })
}
export function* getEntityRows(data) {
  try {
    const response = yield call(showEntityFetch, data.data);
    yield put(formActions.setEntityRows(response.data.data));
  } catch (err) {
    yield put(formActions.setEntityRows(null));
  }
}
// INSERT
export const insertEntityFetch = (data) => {
  return axios({
    method: 'POST',
    url: API.FORM.INSERT_ENTITY,
    withCredentials: true,
    data,
  })
}
export function* insertEntity({ data }) {
  try {
    const dataFinal = cleanValuesFromState(data);
    const response = yield call(insertEntityFetch, dataFinal);
    yield put(formActions.insertEntityResult(response.data));
  } catch (err) {
    yield put(formActions.insertEntityResult({
      infoOp: 'Se ha producido un error inesperado',
      operation: 'error',
    }));
  }
}
// COMMONS
export const formFetch = (data) => {
  return axios({
    method: 'POST',
    url: API.FORM.GET_ENTITY_INFO,
    withCredentials: true,
    data,
  })
}
export function* getEntity({ params }) {
  try {
    const responseAux = yield call(formFetch, { entity: params });
    const response = responseAux.data;
    const { data, error } = response;
    if (error) {
      yield put(formActions.getEntityKO());
    } else {
      yield put(formActions.getEntityOK({ type: params, data }));
    }
  } catch (err) {
    yield put(formActions.getEntityKO());
  }
}

// CREATE PDF
export const createEntityPdfFetch = (data) => {
  return axios({
    method: 'POST',
    url: API.FORM.CREATE_ENTITY_PDF,
    withCredentials: true,
    data,
  })
}
export function* createEntityPdf({ params }) {
  try {
    const responseAux = yield call(createEntityPdfFetch, { 
      entity: params.entityName,
      id: params.entityIdValue,
    });
    const response = responseAux.data;
    if (response.operation == 'success') {
      yield put(formActions.checkEntityPDF(params));
    }
    yield put(formActions.createEntityPDFResult(response));
  } catch (err) {
    console.log(err);
    yield put(formActions.createEntityPDFResult({
      infoOp: 'Ha ocurrido un error inesperado',
      operation: 'error',
    }));
  }
}

// CHECK ENTITY PDF
export const checkEntityPdfFetch = (data) => {
  return axios({
    method: 'POST',
    url: API.FORM.CHECK_ENTITY_PDF,
    withCredentials: true,
    data,
  })
}

export function* checkEntityPdf({ params }) {
  try {
    const responseAux = yield call(checkEntityPdfFetch, { 
      entity: params.entityName,
      id: params.entityIdValue,
    });
    yield put(formActions.setCheckEntityPDFResult(responseAux.data));
  } catch(err) {
    yield put(formActions.setCheckEntityPDFResult({
      infoOp: 'Error inesperado, contacte con su webmaster',
      kind: 'error'
    }));
  }
}


